import {
  contextualGet,
  queryOptions,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from '@eigtech/ui-shared-api'
import { GetDefaultOwnerInfoResponse, GetDefaultOwnerResponse } from '@eigtech/white-label-types'
import { whiteLabelBasePath, whiteLabelQueryKeys } from './constants'

const getDefaultOwner = () =>
  contextualGet<GetDefaultOwnerResponse>(`${whiteLabelBasePath}/default/owner`)

export const getDefaultOwnerQueryOptions = () =>
  queryOptions({
    queryKey: whiteLabelQueryKeys.defaultOwner(),
    queryFn: getDefaultOwner,
  })

export const useGetDefaultOwner = () => useQuery(getDefaultOwnerQueryOptions())

export const useSuspenseGetDefaultOwner = () => useSuspenseQuery(getDefaultOwnerQueryOptions())

export function useInvalidateDefaultOwner() {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: whiteLabelQueryKeys.defaultOwner() })
}

const getDefaultOwnerInfo = () =>
  contextualGet<GetDefaultOwnerInfoResponse>(`${whiteLabelBasePath}/default/info`)

export const getDefaultOwnerInfoQueryOptions = () =>
  queryOptions({
    queryKey: whiteLabelQueryKeys.defaultOwnerInfo(),
    queryFn: getDefaultOwnerInfo,
    // The info (theme especially) is bootstrap data - a background refetch would repaint the whole UI
    staleTime: Infinity,
  })

export const useGetDefaultOwnerInfo = () => useQuery(getDefaultOwnerInfoQueryOptions())

export const useSuspenseGetDefaultOwnerInfo = () =>
  useSuspenseQuery(getDefaultOwnerInfoQueryOptions())

/**
 * Pull the info down again and hand it back. The query is bootstrap data with an
 * infinite staleTime, so it has to be fetched past its own cache to pick up a change
 * made during this session.
 */
export function useRefetchDefaultOwnerInfo() {
  const queryClient = useQueryClient()

  return () => queryClient.fetchQuery({ ...getDefaultOwnerInfoQueryOptions(), staleTime: 0 })
}
